import type { BankTransferStatus } from '../../types/company';

export const BANK_TRANSFER_STORAGE_KEY = 'avs.bankTransferLastResult';

export type { BankTransferStatus };
